import { Typography } from "@mui/material"
import { format } from "date-fns"
import { If, Else } from "lib/@components/switch"
import { EmptyValue, isEmptyValue } from "./requested-field-value-empty"

/**
 * Read-only display of a `date` requested field's answer as an absolute date (`d MMM yyyy`, matching
 * the share-link comments date format). A missing or unparseable value shows the shared placeholder.
 * Counterpart of `date-field-input.js`.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 * @param {string|number|Date} [props.value]
 */
export function DateFieldValue({ value }) {
    const formatted = getFormattedDate()

    return (
        <If value={!!formatted}>
            <Typography variant="body2">{formatted}</Typography>
            <Else>
                <EmptyValue />
            </Else>
        </If>
    )

    function getFormattedDate() {
        if (isEmptyValue(value)) return ""
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return ""
        try {
            return format(date, "d MMM yyyy")
        } catch {
            return ""
        }
    }
}
